import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import CreatableSelect from "react-select/creatable";
import Swal from "sweetalert2";
import companyApi from "../../api/company";
import franchiseAdminAPI from "../../api/franchiseAdminAPI";

const AddAdmin = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [organization, setOrganization] = useState(null);
  const [location, setLocation] = useState("");

  const [email2, setEmail2] = useState("");
  const [organization2, setOrganization2] = useState(null);
  const [location2, setLocation2] = useState("");

  const [enableF2, setEnableF2] = useState(false);
  const [f2ParentType, setF2ParentType] = useState("current");
  const [parent, setParent] = useState(null);

  const [companyList, setCompanyList] = useState([]);
  const [existingParents, setExistingParents] = useState([]);

  const [locationOptions1, setLocationOptions1] = useState([]);
  const [locationOptions2, setLocationOptions2] = useState([]);

  // =========================
  // FETCH COMPANIES
  // =========================
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await companyApi.getAllCompanyNames();
        setCompanyList(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetch();
  }, []);

  // =========================
  // FETCH FA1 (EXISTING FRANCHISES)
  // =========================
  useEffect(() => {
    const fetch = async () => {
      try {
        const res = await franchiseAdminAPI.getFranchises1List();
        setExistingParents(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetch();
  }, []);

  // =========================
  // COMMON LOCATION FETCH + MERGE
  // =========================
  const fetchLocations = async (orgName, setFn) => {
    try {
      const [res1, res2] = await Promise.all([
        companyApi.getLocationsByCompanyName(orgName),
        franchiseAdminAPI.getLocationsByCompanyName(orgName),
      ]);

      const merged = [...(res1.data || []), ...(res2.data || [])];
      const unique = [...new Set(merged)];

      setFn(
        unique.map((loc) => ({
          label: loc,
          value: loc,
        })),
      );
    } catch (err) {
      console.error(err);
    }
  };

  // =========================
  // FRANCHISE 1 LOCATIONS
  // =========================
  useEffect(() => {
    if (!organization?.label) return;
    fetchLocations(organization.label, setLocationOptions1);
  }, [organization]);

  // =========================
  // FRANCHISE 2 LOCATIONS
  // =========================
  useEffect(() => {
    if (!organization2?.label) return;
    fetchLocations(organization2.label, setLocationOptions2);
  }, [organization2]);

  const isDuplicate = (org, loc) => {
    return existingParents.some(
      (f) =>
        f.organization?.toLowerCase() === org?.toLowerCase() &&
        f.location?.toLowerCase() === loc?.toLowerCase(),
    );
  };

  const handleSubmit = async () => {
    try {
      let f1Id = null;

      // =========================
      // STEP 1: CREATE FA1 ONLY IF FILLED
      // =========================
      if (email || organization || location) {
        if (!email || !organization || !location) {
          Swal.fire("Missing", "Fill all Franchise 1 fields", "warning");
          return;
        }
        if (isDuplicate(organization.label, location)) {
          Swal.fire(
            "Duplicate",
            "This organization already exists in this location. Please check once.",
            "error",
          );
          return;
        }
        const f1Payload = {
          email,
          organization: organization.label,
          location,
          parentId: null,
          createdBy: "MASTER ADMIN",
        };

        const f1Res = await franchiseAdminAPI.saveFranchises(f1Payload);
        f1Id = f1Res.data.id;
      }

      // =========================
      // STEP 2: CREATE FA2 (ONLY IF ENABLED)
      // =========================
      if (enableF2) {
        if (!email2 || !organization2 || !location2) {
          Swal.fire("Missing", "Fill Franchise 2", "warning");
          return;
        }

        // validate parent
        if (f2ParentType === "existing" && !parent?.value) {
          Swal.fire("Missing", "Select parent franchise", "warning");
          return;
        }

        const f2Payload = {
          email: email2,
          organization: organization2.label,
          location: location2,
          parentId: f2ParentType === "current" ? f1Id : parent?.value,
          createdBy: "MASTER ADMIN",
        };

        await franchiseAdminAPI.saveFranchises(f2Payload);
      }

      Swal.fire("Success", "Saved successfully", "success");
      navigate("/master-admin-dashboard/franchises");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Something went wrong", "error");
    }
  };

  return (
    <div className="scrollable-container">
      <div className="d-flex justify-content-between mb-3">
        <h3>Add Franchise</h3>
        <Button onClick={() => navigate(-1)} variant="info">
          <IoArrowBackCircleSharp /> Back
        </Button>
      </div>

      <div className="card p-4">
        {/* ================= FRANCHISE 1 ================= */}
        <h5>Franchise 1</h5>

        <label>Email</label>
        <input
          className="form-control mb-2"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <br />
        <label>Organization</label>
        <CreatableSelect
          options={companyList.map((c) => ({
            label: c,
            value: c,
          }))}
          value={organization}
          onChange={setOrganization}
        />
        <br />
        <label className="mt-2">Location</label>
        <CreatableSelect
          options={locationOptions1}
          value={location ? { label: location, value: location } : null}
          onChange={(e) => setLocation(e?.value || "")}
        />

        {/* ================= FRANCHISE 2 ================= */}

        <div className="mt-3">
          <input
            type="checkbox"
            checked={enableF2}
            onChange={(e) => setEnableF2(e.target.checked)}
          />{" "}
          Add Franchise 2
        </div>

        {enableF2 && (
          <>
            <h5 className="mt-3">Franchise 2</h5>
            {/* ================= PARENT SELECTION ================= */}
            <label className="mt-3">Belongs to</label>
            <div>
              <input
                type="radio"
                checked={f2ParentType === "current"}
                onChange={() => setF2ParentType("current")}
              />{" "}
              Current Franchise 1
            </div>
            <div>
              <input
                type="radio"
                checked={f2ParentType === "existing"}
                onChange={() => setF2ParentType("existing")}
              />{" "}
              Existing Franchise
            </div>
            <br />
            {/* EXISTING PARENT DROPDOWN */}
            {f2ParentType === "existing" && (
              <>
                <label>Select Parent Franchise</label>

                <CreatableSelect
                  options={existingParents.map((f) => ({
                    label: `${f.organization} - ${f.location}`,
                    value: f.id,
                  }))}
                  value={parent}
                  onChange={setParent}
                />
              </>
            )}
            <br />
            <label>Email</label>
            <input
              className="form-control mb-2"
              value={email2}
              onChange={(e) => setEmail2(e.target.value)}
            />
            <br />
            <label>Organization</label>
            <CreatableSelect
              options={companyList.map((c) => ({
                label: c,
                value: c,
              }))}
              value={organization2}
              onChange={setOrganization2}
            />{" "}
            <br />
            <label>Location</label>
            <CreatableSelect
              options={locationOptions2}
              value={location2 ? { label: location2, value: location2 } : null}
              onChange={(e) => setLocation2(e?.value || "")}
            />
          </>
        )}

        <div className="text-end mt-3">
          <Button onClick={handleSubmit}>Save</Button>
        </div>
      </div>
    </div>
  );
};

export default AddAdmin;
